import {create} from "zustand";

interface IStore {
    width: number;
    setWidth: (width: number) => void;

    depth: number;
    setDepth: (depth: number) => void;

    auswahl: string;
    setAuswahl: (auswahl: string) => void;

    balkon: string;
    setBalkon: (balkon: string) => void;

    montageart: string;
    setMontageart: (montageart: string) => void;

    wandabstand: string;
    setWandabstand: (wandabstand: string) => void;

    fullung: string;
    setFullung: (fullung: string) => void;

}

export const VStore = create<IStore>((set) => ({
    width: 2.4,
    setWidth: (width: number) => set({width}),

    depth: 1.25,
    setDepth: (depth: number) => set({depth}),

    auswahl: 'stabgelander',
    setAuswahl: (auswahl: string) => set({auswahl}),

    balkon: 'i-form',
    setBalkon: (balkon: string) => set({balkon}),

    montageart: 'aufgesetzt',
    setMontageart: (montageart: string) => set({montageart}),

    wandabstand: '30-mm',
    setWandabstand: (wandabstand: string) => set({wandabstand}),

    fullung: 'mit-exakter-bohrung',
    setFullung: (fullung: string) => set({fullung}),
}));